import { cn } from "@newxsystems/shared";
import type { IRavioliRichTextProps } from "./RavioliRichText.props";

export const RavioliRichText = ({ className, content }: IRavioliRichTextProps) => (
  <div
    className={cn(
      "font-ravioli-body text-[1.0625rem] leading-[1.5625rem] text-pretty text-foreground md:text-lg md:leading-[1.6875rem] [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_blockquote]:border-l [&_blockquote]:border-line [&_blockquote]:pl-6 [&_blockquote]:text-ink-muted [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-5 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

RavioliRichText.displayName = "Content::RavioliRichText";
